import { FormItem } from "../interfaces/FormItem.interface";

/**
 * [Pure] Flattens a form item and its children recursively.
 * @param arr 
 * @param item 
 */
export function itemReducer(arr: Array<FormItem>, item: FormItem): Array<FormItem> {
    arr.push(item);
    if(!item.items) return arr;
    return item.items.reduce(itemReducer, arr);
}
